import Button from "e.sic-platform.webclient/src/components/button/Button";
import { RunAI } from "e.sic-platform.webclient/src/components/svg/svgImageList";
import useThemeService from "e.sic-platform.webclient/src/services/theme-service/ThemeService";

export default function RunVideoAnalysisButton(props:{onClick: () => void, disabled?: boolean}) {
  const { themeClass } = useThemeService();

  return (
    <Button
        id="run-ai-sc"
        onClick={props.onClick}
        disabled={props.disabled}
        icon={{
          svg: RunAI,
          textKey: "RunVideoAnalysisButton.run",
          className: themeClass(["icon-custom"]),
        }}
        className={themeClass(["btn-huge", "run-ai-button"])}
      />
  )
}
